import { useLanguage } from "@web/lib/contexts/language-context";
import { flashVariants } from "@web/styles/motion-variants";
import { AnimatePresence, motion } from "framer-motion";
import { LoaderCircle } from "lucide-react";

type CameraInitializingOverlayProps = {
	visible: boolean;
};

export const CameraInitializingOverlay = ({
	visible,
}: CameraInitializingOverlayProps) => {
	const { t } = useLanguage();

	return (
		<AnimatePresence>
			{visible && (
				<motion.div
					className="absolute z-20 flex flex-col items-center justify-center gap-3 text-white"
					variants={flashVariants}
					initial="hidden"
					animate="visible"
					exit="exit"
				>
					<motion.div
						animate={{
							rotate: [0, 360],
							transition: {
								duration: 1.5,
								repeat: Number.POSITIVE_INFINITY,
							},
						}}
					>
						<LoaderCircle className="h-10 w-10 text-primary" />
					</motion.div>
					<p className="text-sm text-white/80">
						{t.camera.waitingWhileCameraLoads}
					</p>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
